<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div
            class="card-header pb-0 d-flex justify-content-between align-items-center"
          >
            <h6>部落格分類管理</h6>
            <button class="btn btn-sm btn-success mb-0" @click="openModal()">
              新增分類
            </button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      名稱
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Slug
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      文章數
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="category in categories" :key="category.id">
                    <td>
                      <div class="d-flex px-3 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ category.name }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ category.slug }}
                      </p>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ category.posts_count || 0 }}
                      </span>
                    </td>
                    <td class="align-middle">
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs me-3"
                        @click="openModal(category)"
                      >
                        編輯
                      </a>
                      <a
                        href="javascript:;"
                        class="text-danger font-weight-bold text-xs"
                        @click="deleteCategory(category.id)"
                      >
                        刪除
                      </a>
                    </td>
                  </tr>
                  <tr v-if="categories.length === 0">
                    <td colspan="4" class="text-center py-4 text-secondary">
                      尚無分類
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      v-if="showModal"
      class="modal fade show d-block"
      style="background: rgba(0, 0, 0, 0.5)"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ form.id ? "編輯分類" : "新增分類" }}
            </h5>
            <button
              type="button"
              class="btn-close text-dark"
              @click="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitForm">
              <div class="mb-3">
                <label class="form-label">名稱</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.name"
                  required
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Slug (網址代稱)</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.slug"
                  placeholder="留空將自動生成"
                />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="submitForm"
              :disabled="loading"
            >
              {{ loading ? "儲存中..." : "儲存" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import Swal from "sweetalert2";

export default {
  name: "BlogCategories",
  data() {
    return {
      categories: [],
      showModal: false,
      loading: false,
      form: {
        id: null,
        name: "",
        slug: "",
      },
    };
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await request.get("/api/admin/blog/categories");
        // API might return { data: [...] } or { data: { data: [...] } }
        this.categories = response.data.data || response.data;
      } catch (error) {
        console.error("Failed to fetch categories", error);
      }
    },
    openModal(category = null) {
      if (category) {
        this.form = {
          id: category.id,
          name: category.name,
          slug: category.slug,
        };
      } else {
        this.form = {
          id: null,
          name: "",
          slug: "",
        };
      }
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    async submitForm() {
      if (!this.form.name) {
        Swal.fire("錯誤", "請輸入分類名稱", "error");
        return;
      }

      this.loading = true;
      try {
        const data = {
          name: this.form.name,
          slug: this.form.slug,
        };

        if (this.form.id) {
          await request.put(`/api/admin/blog/categories/${this.form.id}`, data);
        } else {
          await request.post("/api/admin/blog/categories", data);
        }

        this.closeModal();
        this.fetchCategories();
        Swal.fire("成功", "分類已儲存", "success");
      } catch (error) {
        console.error("Failed to save category", error);
        Swal.fire("錯誤", error.response?.data?.message || "儲存失敗", "error");
      } finally {
        this.loading = false;
      }
    },
    async deleteCategory(id) {
      this.$swal({
        title: "確定要刪除此分類嗎？",
        text: "此操作無法復原",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ea0606",
        confirmButtonText: "確定刪除",
        cancelButtonText: "取消",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await request.delete(`/api/admin/blog/categories/${id}`);
            this.fetchCategories();
            this.$swal.fire("已刪除", "分類已成功刪除。", "success");
          } catch (error) {
            console.error("Failed to delete category", error);
            this.$swal.fire(
              "錯誤",
              "刪除失敗，可能仍有文章關聯此分類",
              "error"
            );
          }
        }
      });
    },
  },
  created() {
    this.fetchCategories();
  },
};
</script>
